import React from 'react';

// Simple editorial text wordmark for Lawork.
// Lowercase serif with a subtle period — quiet, human, not-tech.
export const Logo = ({ className = '', small = false }) => {
  return (
    <span
      className={`inline-flex items-baseline font-serif leading-none select-none ${className}`}
      style={{ letterSpacing: '-0.02em' }}
    >
      <span
        className={small ? 'text-2xl' : 'text-3xl md:text-[2rem]'}
        style={{ fontWeight: 500, color: 'var(--ink)' }}
      >
        lawork
      </span>
      <span
        className={small ? 'text-2xl' : 'text-3xl md:text-[2rem]'}
        style={{ color: 'var(--accent)', marginLeft: '1px' }}
      >
        .
      </span>
    </span>
  );
};

export default Logo;
